// شاخص شدت آلودگی شهر — از دکمهٔ «شاخص شدت آلودگی» فرم شهرها
import React from 'react';
import { ui } from '../../components/ListPage';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import CrudView from './CrudView';
import { Field, TextInput, Lookup } from './basicShared';

const COLS = [
  { key: 'letter_no', label: 'شماره' }, { key: 'letter_date', label: 'تاریخ' }, { key: 'contractor', label: 'شرکت آلاینده' },
  { key: 'pollution_index', label: 'شاخص آلایندگی', num: true }, { key: 'remark', label: 'توضیح' },
  { key: 'scan', label: 'اسکن', num: true },
];

function Fields({ f, set, setMany }) {
  return (
    <>
      <div style={ui.row}>
        <Field label="شماره" width="150px"><TextInput value={f.letter_no} onChange={v => set('letter_no', v)} ltr autoFocus /></Field>
        <Field label="تاریخ" width="160px"><JalaliDatePicker value={f.letter_date} onChange={v => set('letter_date', v)} /></Field>
        <Field label="شاخص آلایندگی" width="120px"><TextInput value={f.pollution_index} onChange={v => set('pollution_index', v)} ltr /></Field>
      </div>
      <div style={ui.row}>
        <Lookup label="شرکت آلاینده" text={f.contractor} endpoint="/city-pollution/lookup/contractor/"
          onPick={r => setMany({ contractor_code: r.id, contractor: r.title || '' })} />
      </div>
      <div style={ui.row}>
        <Field label="توضیح"><TextInput value={f.remark} onChange={v => set('remark', v)} /></Field>
      </div>
    </>
  );
}

/** props: city {id, name}، onClose */
export default function CityContractorPollution({ city, onClose }) {
  return (
    <CrudView asDialog onClose={onClose} form="FRMCITYCONTRACTORPOLLUTION" title={`درصد آلایندگی شهر: ${city.name}`}
      path={`/cities/${city.id}/pollution`} cols={COLS} reloadKey={city.id}
      empty={{ letter_no: '', letter_date: '', contractor_code: 0, contractor: '', pollution_index: '', remark: '' }}
      toForm={r => ({ ...r, pollution_index: String(r.pollution_index ?? '') })} renderFields={Fields} />
  );
}
